import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function PreferencesPageToggleWrapper(
  props: {
    children: ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.PREFERENCES_PAGE}>
      {props.children}
    </ToggleWrapper>
  );
}
